<template>
  <AdaptiveSheet @open="cropperEditOpen=true" class="editImage" :tablet-fullscreen="false" :backdrop="true" :close-on-escape="true" full-screen>
    <f7-view>
      <f7-page class="editImage-page">
        <f7-navbar no-shadow no-hairline class="editImage-navbar">
          <f7-nav-title class="editImage-nav-title">{{ document?.fileName || $t("common.edit") }}</f7-nav-title>
          <f7-nav-right>
            <f7-link sheet-close popup-close icon-f7="multiply" icon-size="22"></f7-link>
          </f7-nav-right>
        </f7-navbar>

        <div class="editImage-body">
          <div v-if="document && document.fileType === 'image'" class="editImage-stage">
            <imageCropper v-if="document && document.fileType === 'image' && cropperEditOpen" :imageSrc="document" :isToSave="false" ref="image_cropper" />
          </div>
          <div v-else class="editImage-empty">
            <f7-icon f7="photo_on_rectangle" size="56"></f7-icon>
          </div>
        </div>

        <f7-toolbar bottom class="editImage-footer padding-top "  style="bottom:0px">
          <f7-button large raised  strong fill class="editImage-save" @click="saveEditedImage()">
            <f7-icon f7="checkmark_alt" size="18"></f7-icon>
            <span>{{ $t("editdocs.saveDocument") }}</span>
          </f7-button>
        </f7-toolbar>
      </f7-page>
    </f7-view>
  </AdaptiveSheet>
</template>
<style scoped lang="scss">
.editImage {
  z-index: 200000 !important;
  background: var(--avocash-surface, #f4f7f2);
}

.editImage-page {
  display: flex;
  flex-direction: column;
  background: var(--avocash-surface, #f4f7f2);
}

.editImage-navbar {
  --f7-navbar-bg-color: #ffffff;
  --f7-navbar-text-color: var(--avocash-pit, #1c1c1e);
}

.editImage-nav-title {
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.editImage-body {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.editImage-stage {
  width: 100%;
  max-width: 720px;
  height: 100%;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--f7-card-bg-color, #fff);
  border: 1px solid rgba(28, 28, 30, 0.06);
  border-radius: 20px;
  box-shadow: 0 12px 32px rgba(28, 28, 30, 0.08);
  overflow: hidden;
}

.editImage-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(28, 28, 30, 0.3);
}

.editImage-footer {
  // padding: 12px 16px calc(12px + var(--f7-safe-area-bottom));
  background: var(--f7-card-bg-color, #fff);
  border-top: 1px solid rgba(28, 28, 30, 0.06);
}

.editImage-save {
  width: 100%;
  height: 48px;
  --f7-button-fill-bg-color: var(--avocash-green, #1a6b42);
  --f7-button-fill-text-color: #ffffff;
  --f7-button-border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.2px;
  box-shadow: 0 10px 24px rgba(26, 107, 66, 0.28);
  bottom:0px;
  position: absolute;
}
</style>
<script setup>
import { f7, theme } from "framework7-vue";
import { ref, onMounted } from "vue";
import imageCropper from "./imageCropper.vue";
import { useAttachDocs } from '@/js/composables/useAttachDocs.js'
import { storeToRefs } from "pinia";
import AdaptiveSheet from "./common/AdaptiveSheet.vue";
import { closeAdaptiveModal } from "../js/composables/useAdaptiveModal.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const accountStore = useAccountStore();
const authStore = useAuthStore();
const { primaryAccount, businessAccount } = storeToRefs(accountStore);
const { getProfile, isAuthenticated, isProfileLoaded, profile, documentsUrl, document } = storeToRefs(authStore);
const cropperEditOpen=ref(false);
const image_cropper = ref(null);
const image = ref(null);

const { attachFileOpenActions, getFileMimeType, removeDoc, editImage, photoList } = useAttachDocs({ f7route: props.f7route, f7router: props.f7router });

async function saveEditedImage() {
  const file = await image_cropper.value?.saveCroppedImage();
  if (!file) return;
  closeAdaptiveModal(".editImage");
}
</script>
